module.exports = __webpack_public_path__ + "media/images/icons/person-plus-2568ecff4c3097df34489457b81ccc5c.svg";